import { render, staticRenderFns } from "./OsDatatable.vue?vue&type=template&id=13a06836&scoped=true"
import script from "./OsDatatable.vue?vue&type=script&lang=ts"
export * from "./OsDatatable.vue?vue&type=script&lang=ts"
import style0 from "./OsDatatable.vue?vue&type=style&index=0&id=13a06836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a06836",
  null
  
)

export default component.exports